import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "setting-component" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = {
  for: "bidding-duration",
  class: "form-label"
}
const _hoisted_4 = { value: 0 }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  for: "warning-flashing-duration",
  class: "form-label"
}
const _hoisted_8 = { value: 0 }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-group stage-b-item" }
const _hoisted_11 = {
  for: "third-button",
  class: "form-label"
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "action-block" }

import { trans } from "@/utils/trans";
  import { computed, ref, watch } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import SettingThirdButton from "../../../../../enum/SettingThirdButton";
  import apiClient from "@/services/api";
  import CustomCheckbox from "@/components/_partials/widget/CustomCheckbox.vue";
  import { useToast } from "primevue/usetoast";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Interface',
  setup(__props) {

  const toast = useToast();
  const auctionStore = useAuctionStore();

  const options = computed<{ value: number; label: string }[]>(() => {
    const result = [] as { value: number; label: string }[];
    for (let i = 1; i <= 300; i++) {
      result.push({
        value: i,
        label: `${i} sec`
      });
    }

    return result;
  });

  const interfaceData = ref({
    bidding_duration: auctionStore.liveSettings?.bidding_duration,
    warning_flashing_duration: auctionStore.liveSettings?.warning_flashing_duration,
    third_button: auctionStore.liveSettings?.third_button,
    show_bid_increments: auctionStore.liveSettings?.show_bid_increments
  });

  watch(
    () => auctionStore.liveSettings,
    (nv) => {
      interfaceData.value.bidding_duration = nv?.bidding_duration;
      interfaceData.value.warning_flashing_duration = nv?.warning_flashing_duration;
      interfaceData.value.third_button = nv?.third_button;
      interfaceData.value.show_bid_increments = nv?.show_bid_increments;
    },
    { deep: true }
  );

  const save = () => {
    apiClient.put(auctionStore.routes["auctions.update_live_settings"], interfaceData.value).then((response) => {
      if (response.data.status && response.data.settings) {
        auctionStore.$patch(response.data.settings);
      } else {
        console.log(response, response.data?.message);
      }
      toast.add({
        severity: response.data.status ? "success" : "error",
        summary: trans("live.toast." + (response.data.status ? "success" : "error")),
        detail: response.data.message || trans("live.toast.unknown_error"),
        life: 6000
      });
    });
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(trans)("live.tabs.settings.interface_tab.labels.bidding_duration")), 1),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((interfaceData.value.bidding_duration) = $event)),
        id: "bidding-duration",
        class: "form-select-field"
      }, [
        _createElementVNode("option", _hoisted_4, _toDisplayString(_unref(trans)("live.tabs.settings.interface_tab.bidding_duration_off")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.value,
            key: option.value
          }, _toDisplayString(option.label), 9, _hoisted_5))
        }), 128))
      ], 512), [
        [_vModelSelect, interfaceData.value.bidding_duration]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(trans)("live.tabs.settings.interface_tab.labels.warning_flashing_duration")), 1),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((interfaceData.value.warning_flashing_duration) = $event)),
        id: "warning-flashing-duration",
        class: "form-select-field"
      }, [
        _createElementVNode("option", _hoisted_8, _toDisplayString(_unref(trans)("live.tabs.settings.interface_tab.warning_flashing_duration_off")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.value,
            key: option.value
          }, _toDisplayString(option.label), 9, _hoisted_9))
        }), 128))
      ], 512), [
        [_vModelSelect, interfaceData.value.warning_flashing_duration]
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(trans)("live.tabs.settings.interface_tab.labels.third_button")), 1),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((interfaceData.value.third_button) = $event)),
        id: "third-button",
        class: "form-select-field"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SettingThirdButton), (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option,
            key: option
          }, _toDisplayString(_unref(trans)(`live.tabs.settings.interface_tab.third_button.${option}`)), 9, _hoisted_12))
        }), 128))
      ], 512), [
        [_vModelSelect, interfaceData.value.third_button]
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(CustomCheckbox, {
        id: "show-bid-increments",
        modelValue: interfaceData.value.show_bid_increments,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((interfaceData.value.show_bid_increments) = $event)),
        label: _unref(trans)('live.tabs.settings.interface_tab.labels.show_bid_increments')
      }, null, 8, ["modelValue", "label"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        class: "action btn btn-blue",
        onClick: save
      }, _toDisplayString(_unref(trans)("live.tabs.settings.labels_tab.actions.save")), 1)
    ])
  ]))
}
}

})